module.exports = __webpack_public_path__ + "static/img/prq4.37399bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/prq4.jpg
// module id = xfrc
// module chunks = 2